import { PRIVATE_URIS } from '../constants/privateURIs.constants';

/**
 * TRIL-367: builds the per-reply Story Analysis route from its PRIVATE_URIS
 * template, keeping the '/reply/:replyId/analysis' shape in one source of truth
 * (mirrors `postAnalysisPath`).
 */
export function replyAnalysisPath(replyId: string): string {
  return PRIVATE_URIS.REPLY_ANALYSIS.replace(':replyId', replyId);
}
